<template>
  <base-dropdown
    tag="li"
    :menu-on-right="!$rtl.isRTL"
    title-tag="a"
    class="nav-item"
    title-classes="nav-link"
    menu-classes="dropdown-navbar"
  >
    <template slot="title">
      <div class="d-none d-lg-block d-xl-block"></div>
      <i class="mdi mdi_icon mdi-24px mdi-web mr-1"></i>{{$t('navbar.language', {locale: $i18n.locale})}}
    </template>
    <li class="nav-link">
      <a role="button" class="nav-item dropdown-item" @click="setLocale('en')">EN</a>
    </li>
    <li class="nav-link">
      <a role="button" class="nav-item dropdown-item" @click="setLocale('lt')">LT</a>
    </li>
  </base-dropdown>
</template>
<script>

export default {
  name: 'locale-switch',
  methods: {
    setLocale(locale) {
      this.$store.dispatch('SetLocale', locale)
    }
  }
};
</script>
